<template>
  <div class="toastification">
    <div class="d-flex align-items-start">
      <b-avatar
        size="1.8rem"
        class="mr-75 flex-shrink-0"
      >
        <feather-icon :icon="icon" size="15" />
      </b-avatar>
      <div class="d-flex flex-grow-1">
        <div>
          <h5
            class="mb-0 font-weight-bolder toastification-title"
            :class="`text-${variant}`"
            v-text="resolveWindowText(title)" />
          <small class="d-inline-block text-body"
            v-text="resolveWindowText(text)"/>
        </div>
        <span
          class="cursor-pointer toastification-close-icon ml-auto"
          @click="$emit('close-toast')"
        >
          <feather-icon v-if="!hideClose" icon="XIcon" class="text-body" />
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { BAvatar } from "bootstrap-vue";
import store from "@/store";

export default {
  components: {
    BAvatar,
  },
  props: {
    variant: {
      type: String,
      default: "primary",
    },
    icon: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
    text: {
      type: String,
      default: null,
    },
    params: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    trans() {
      return store.getters["i18n/messages"]("grid");
    },
  },
  methods: {
    resolveWindowText(text) {
      const resolved = text.includes('.')
        ? this.getValueByPath(this.trans, text, "")
        : text;

      return this.interpolate(resolved);
    },
    interpolate(text) {
      if (!text) return text;

      return String(text).replace(/\{(\w+)\}/g, (match, key) =>
        this.params[key] !== undefined ? this.params[key] : match
      );
    },
    getValueByPath (obj, path, defaultValue = null) {
        return path.split('.').reduce(
            (acc, key) => acc?.[key],
            obj
        ) ?? defaultValue;
    }
  },
};
</script>

<style lang="scss" scoped>
.toastification-close-icon,
.toastification-title {
  line-height: 26px;
}

.toastification-title {
  color: inherit;
}
</style>
